import { Theme } from '@mui/material';

export const getSelectStyles = (theme: Theme) => ({
  borderRadius: theme.backrs.radius['radius-md'],
  backgroundColor: theme.backrs.colors['Colors/Background/bg-primary'],
  border: `1px solid ${theme.backrs.colors['Colors/Foreground/fg-quaternary']}`,
  alignSelf: 'center',
  cursor: 'pointer',
  minHeight: 'unset',
  padding: 'unset',
  transition: 'all 0.3s ease-in-out',
  '& .MuiOutlinedInput-input': {
    paddingRight: `${theme.backrs.spacing['spacing-none']} !important`,
  },
  '& .MuiInputBase-root': {
    paddingRight: `${theme.backrs.spacing['spacing-none']} !important`,
  },
  '& .MuiSelect-select': {
    padding: theme.backrs.spacing['spacing-md'],
  },
  '& .MuiSelect-icon': {
    display: 'none',
  },
  '&:hover': {
    border: `1px solid ${theme.backrs.colors['Colors/Foreground/fg-primary']}`,
    boxShadow: theme.backrs.shadows['shadow-lg'],
  },
  '&:focus': {
    border: `1px solid ${theme.backrs.colors['Colors/Foreground/fg-primary']}`,
  },
  '&.Mui-focused': {
    outline: 'none',
    boxShadow: theme.backrs.shadows['shadow-lg'],
    border: `1px solid ${theme.backrs.colors['Colors/Foreground/fg-primary']}`,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
});

export const getSelectMenuPaperStyles = (theme: Theme) => ({
  mt: theme.backrs.spacing['spacing-md'],
  boxShadow: theme.backrs.shadows['shadow-xl'],
  border: `1px solid ${theme.backrs.colors['Colors/Foreground/fg-primary']}`,
  borderRadius: theme.backrs.radius['radius-md'],
});

export const getMenuItemStyles = (theme: Theme) => ({
  '&.Mui-selected': {
    backgroundColor: theme.backrs.colors['Colors/Base/Transparent'],
    '&:hover': {
      backgroundColor: theme.backrs.colors['Colors/Base/Transparent'],
    },
  },
  '&.MuiMenuItem-root:hover': {
    backgroundColor: 'transparent !important',
  },
  '&.Mui-focusVisible': {
    backgroundColor: 'transparent !important',
  },
});

export const getMenuItemContentStyles = (theme: Theme) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: theme.backrs.spacing['spacing-lg'],
  width: '100%',
});

export const getMenuItemIconStyles = (isChecked: boolean, theme: Theme) => ({
  width: '16px',
  height: '16px',
  backgroundColor: isChecked
    ? theme.backrs.colors['Colors/Background/bg-brand-solid']
    : 'transparent',
  borderRadius: theme.backrs.radius['radius-xs'],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: isChecked ? `1px solid ${theme.backrs.colors['Colors/Base/Black']}` : 'none',
});
